module.exports = __webpack_public_path__ + "img/lab44.1a897b1d.png";